export enum DefaultAppSettingsEndPoints {
    CLEAR_APP_LIST = 'DeleteApplicationList/ApplicationList_',
}

export enum DefaultAppSettingsReactQueryKey {
    CLEAR_APP_LIST = 'CLEAR_APP_LIST'
}
